import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n.js';

import Vant from 'vant';
import 'vant/lib/index.css';
import store from './store/index.js';
import setPageTitle from './utils/setPageTitle.js';
import { Lazyload } from 'vant';

/**
 * vue 开发中 IOS 手机对 vue-router 路由设置没有反应，
 * 所以 IOS 手机记录的永远是第一次进入页面的地址，
 * 所以当调用 wx.config() 时注册的并不是当前页面的 url ，因此导致签名错误。
 *
 * 解决方法：记录第一次 进入的链接 在注册的时候 判断是否是ios 进行相对于的修改。
 */
sessionStorage.setItem('_iosWXConfig_', location.href);

setPageTitle();

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
	lazyComponent: true
});

Vue.use(Vant);

Vue.config.productionTip = false;

Vue.mixin({
	data() {
		return {
			lang: localStorage.getItem('lang') || 'zh'
		};
	},
	methods: {
		getLangText(obj, key) {
			if (this.lang === 'en') {
				return obj[`${key}En`] || obj[key];
			}

			return obj[key];
		}
	}
});

new Vue({
	router,
	store,
	i18n,
	//第一次访问的时候并没有实现自动切换语言的功能，但是在localStorage中看到lang已经被赋值，只有当页面再次刷新的时候才生效了。解决这个问题的办法就是将i18n.locale属性配置放入Vue中来，这样加载系统的时候就会自动去刷新i18n.locale属性了
	created() {
		i18n.locale = localStorage.getItem('lang') || 'zh';
	},
	render: h => h(App)
}).$mount('#app');
